import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, first, map, tap } from 'rxjs/operators';
import { selectCurrentRoom } from '../stores/rooms/rooms.selector';
import { AttributesResolverAttributesRequested } from '../sub-features/room/attributes/attributes-store/attributes.actions';

@Injectable({ providedIn: 'root' })
export class AttributesResolverService {
  private readonly store = inject(Store);

  resolve(): Observable<boolean> {
    return this.store.select(selectCurrentRoom).pipe(
      filter((x) => !!x),
      tap((room) => {
        if (room?.PmsReferenceCode) {
          this.store.dispatch(new AttributesResolverAttributesRequested({ reservationId: room.PmsReferenceCode }));
        }
      }),
      map((room) => !!room?.PmsReferenceCode),
      first()
    );
  }
}
